import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Accordion, Card } from "react-bootstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { AdminService } from "../../../services/admin-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer } from "react-toastify";

export const Content = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");

  const history = useHistory();
  const [submitloading, setSubmitLoading] = useState(true);


  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
      setSubmitLoading(false);
    try {
      await AdminService.adminResetNewPassword(email, values.newPassword);

      setSubmitLoading(true);
      notify("Your password has been successfully reset");
      history.replace("/login")
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  return (
    <div className="ms-content-wrapper ms-auth">
      <div>
        <ToastContainer />
      </div>
      <div className="ms-auth-container">
        <div className="ms-auth-col">
          <div className="ms-auth-bg" />
        </div>
        <div className="ms-auth-col">
          <div className="ms-auth-form">
            <Formik
              initialValues={{
                newPassword: "",
                confirmPassword: "",
              }}
                validationSchema={Yup.object().shape({
                  newPassword: Yup.string()
                    .required("Required")
                    .min(6, "password must have at least 6 characters")
                    .max(10, "password must have less than 10 characters"),

                  confirmPassword: Yup.string().when("newPassword", {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf(
                      [Yup.ref("newPassword")],
                      "Both password need to be the same"
                    ),
                  }),
                    
                })}

              onSubmit={onSubmitForm}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                touched,
                values,
                submitForm,
                isValid,
              }) => (
                <form>
                  <h3>Reset Your Password</h3>
                  <p>Enter a new password below to change your password.</p>
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">New Password</label>
                    <div className="input-group">
                    <input
                      type="password"
                      name="newPassword"
                      className="form-control"
                      id="validationCustom08"
                      placeholder="New Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.newPassword && errors.newPassword}
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">Confirm Password</label>
                    <div className="input-group">
                    <input
                      type="password"
                      name="confirmPassword"
                      className="form-control"
                      id="validationCustom08"
                      placeholder="Confirm Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.confirmPassword && errors.confirmPassword}
                    </div>
                  </div>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    type="button"
                    onClick={submitForm}
                  >
                    Save
                  </button>
                  <p className="mb-0 mt-3 text-center">
                    Go Back{" "}
                    <Link className="btn-link" to="/login">
                      Login
                    </Link>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
